import { DisposalSet, select } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

const gc = new DisposalSet();

registerFragment('ay-property-listing-map-card-list', (fragEl, config, meta) => {
    const mapListEl = select<HTMLDivElement>(fragEl, '.ay-property-listing-map-card-list');

    const toggleExpandEl = fragEl.querySelector<HTMLButtonElement>(
        '.ay-property-listing-map-card-list__toggle-btn--expand'
    );
    const toggleCollapseEl = fragEl.querySelector<HTMLButtonElement>(
        '.ay-property-listing-map-card-list__toggle-btn--collapse'
    );

    if (toggleExpandEl && toggleCollapseEl) {
        gc.register(toggleExpandEl).addListener('click', () => {
            mapListEl.classList.add('ay-property-listing-map-card-list--expanded');
        });
        gc.register(toggleCollapseEl).addListener('click', () => {
            mapListEl.classList.remove('ay-property-listing-map-card-list--expanded');
        });
    }

});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
